export const createPath = (path: string, params: any = {}) => {
    let res = path;
    Object.entries(params).forEach(([key, value]: [string, any]) => {
        res = res.replace(`:${key}`, value);
    });
    return res;
};

export const paths = {
    admin: '/admin',
    adminDetails: '/admin/:id',
    bills: '/bills',
    billsCreditNotes: '/bills/credit_notes',
    billsCreditNotesAdd: '/bills/credit_notes/add',
    billsExceptionalCreditNotes: '/bills/exceptional_credit_notes',
    billsExceptionals: '/bills/exceptionals',
    billsExceptionalsAdd: '/bills/exceptionals/add',
    billsMonthCreditNotes: '/bills/month_credit_notes',
    billsPartner: '/bills/partner',
    billsPartnerDetails: '/bills/partner/:id',
    billsPartnerEdit: '/bills/partner/:id/edit',
    billsPartnerPending: '/bills/partner/pending',
    billsPartnerTransactions: '/bills/partner/transactions',
    billsPeriods: '/bills/periods',
    billsPeriodsPending: '/bills/periods/pending',
    billsRectifications: '/bills/rectifications',
    billsRectificationsAdd: '/bills/rectifications/add',
    billsSimple: '/bills/simple',
    bookings: '/bookings',
    bookingsDetails: '/bookings/:id',
    bookingsRefund: '/bookings/:id/refund',
    contracts: '/newCompanies',
    contractsDetails: '/newCompanies/:id',
    contractsEdit: '/newCompanies/:id/edit',
    controlTowers: '/control_towers',
    controlTowersAdd: '/control_towers/add',
    companies: '/companies',
    companiesAdd: '/companies/add',
    companiesContractEdit: '/companies/:id/contract/:idc/edit',
    companiesContracts: '/companies/:id/contracts',
    companiesContractsAdd: '/companies/:id/contracts/add',
    companiesDepartments: '/companies/:id/departments',
    companiesDepartmentsAdd: '/companies/:id/departments/add',
    companiesDetails: '/companies/:id',
    companiesEdit: '/companies/:id/edit',
    companiesMemberships: '/companies/:id/memberships',
    companiesMembershipsAdd: '/companies/:id/memberships/add',
    companiesRestrictions: '/companies/:id/restrictions',
    driverCommunications: '/driver_communications',
    driverCommunicationsAdd: '/driver_communications/add',
    driverCommunicationsEdit: '/driver_communications/:id/edit',
    drivers: '/drivers',
    driversDetails: '/drivers/:id',
    driversEdit: '/drivers/:id/edit',
    driversStats: '/drivers/secret-stats',
    driversIssues: '/drivers/issues',
    forgot: '/forgot',
    home: '/',
    login: '/login',
    marketing: '/marketing',
    marketingFidB2C: '/marketing/fidb2c',
    marketingPromos: '/marketing/promos',
    marketingPromosAdd: '/marketing/promos/add',
    partners: '/partners',
    partnersAdd: '/partners/add',
    partnersDetails: '/partners/:id',
    partnersDrivers: '/partners/:id/drivers',
    partnersDriversAdd: '/partners/:id/drivers/add',
    partnersEdit: '/partners/:id/edit',
    partnersManagers: '/partners/:id/managers',
    partnersManagersAdd: '/partners/:id/managers/add',
    partnersManagersDetails: '/partners/:id/managers/:idm',
    partnersManagersEdit: '/partners/:id/managers/:idm/edit',
    partnersVehicles: '/partners/:id/vehicles',
    partnersVehiclesAdd: '/partners/:id/vehicles/add',
    prebooks: '/prebooks',
    prebooksAdd: '/prebooks/add',
    prebooksDetails: '/prebooks/:id',
    prebooksPlannings: '/prebooks/:id/plannings',
    pricing: '/pricing',
    pricingManageAreas: '/pricing/manage_areas',
    pricingManageAreasAdd: '/pricing/manage_areas/add',
    pricingManageAreasDetails: '/pricing/manage_areas/:id',
    pricingManageFees: '/pricing/manage_fees',
    pricingManageFeesAdd: '/pricing/manage_fees/add',
    pricingManagePrices: '/pricing/manage_prices',
    pricingManagePricesAdd: '/pricing/manage_prices/add',
    pricingManagePricesDetails: '/pricing/manage_prices/:id',
    pricingManagePricesNewTarifDispo: '/pricing/manage_prices/:id/new_tarif_dispo',
    pricingManagePricesNewTarifForfait: '/pricing/manage_prices/:id/new_tarif_forfait',
    pricingManagePricesNewTarifHkm: '/pricing/manage_prices/:id/new_tarif_hkm',
    profil: '/profil',
    ranks: '/ranks',
    ranksAdd: '/ranks/add',
    ranksEdit: '/ranks/:id/edit',
    ridesImport: '/rides/import',
    ranksDetails: '/ranks/:id',
    reservations: '/reservations',
    reservationsAdd: '/reservations/add',
    reservationsDetails: '/reservations/:id',
    reservationsEdit: '/reservations/:id/edit',
    reservationsRecurrents: '/reservations/recurrents',
    reserver: '/reserver',
    reserverAdd: '/reserver/:id/add',
    reserverDetails: '/reserver/:id',
    rides: '/rides',
    ridesDetails: '/rides/:id',
    riders: '/riders',
    ridersDetails: '/riders/:id',
    ridersEdit: '/riders/:id/edit',
    ridersPromotion: '/riders/:id/promotion',
    snappay: '/snappay',
    support: '/support',
    ticketingDetails: '/ticketing/:project',
    ticketing: '/ticketing',
    ticketingProjectAdd: '/ticketing/:project/add',
    users: '/users',
    usersDetails: '/users/:id',
    usersEdit: '/users/:id/edit',
    vehicles: '/vehicles',
    vehiclesDetails: '/vehicles/:id',
    vehiclesEdit: '/vehicles/:id/edit',
    vehiclesTypes: '/vehicles/types',
    vehiclesTypesAdd: '/vehicles/types/add',
    viadialog: '/viadialog',
};
